var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 176,
    viewBox: "0 0 277 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4065 53.7546H2.3606V57.2604H30.4065V53.7546Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1161 53.7546H61.0817V57.2604H82.1161V53.7546Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.526 53.7546H178.816V57.2604H256.526V53.7546Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2599 22.2031L12.2935 16.0681V2.04517H54.3623V15.1917L49.9801 21.911L47.3508 20.1581L51.1487 14.0231V5.5509H15.507V14.8995L19.8892 19.866L17.2599 22.2031Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6095 12.2701H13.7543V13.7309H52.6095V12.2701Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8893 8.47217H18.4286V13.1465H19.8893V8.47217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5636 8.47217H23.1029V13.1465H24.5636V8.47217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7771 8.47217H26.3164V12.5622H27.7771V8.47217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8672 8.47217H30.4065V12.5622H31.8672V8.47217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8336 8.47217H35.3729V12.5622H36.8336V8.47217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9237 8.47217H39.463V13.1465H40.9237V8.47217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8451 8.47217H42.3844V12.5622H43.8451V8.47217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2273 8.47217H46.7666V13.1465H48.2273V8.47217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3411 21.6187H89.7118V11.978L62.8345 11.6858V21.6187H60.2052V9.05652L92.3411 9.34866V21.6187Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5768 10.8095H80.9475V7.30374H73.3517V10.5173H70.7224V4.67444H83.5768V10.8095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8009 15.1917H66.3402V21.6188H67.8009V15.1917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.891 15.1917H70.4303V21.6188H71.891V15.1917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5653 15.1917H75.1046V21.6188H76.5653V15.1917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4867 15.1917H78.026V21.6188H79.4867V15.1917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.161 15.1917H82.7003V21.6188H84.161V15.1917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5432 15.1917H87.0825V21.6188H88.5432V15.1917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.807 21.9108H246.885V10.8094H231.11V21.9108H228.48V8.18005H249.807V21.9108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.492 13.7308H234.031V21.9109H235.492V13.7308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.874 13.7308H238.413V21.9109H239.874V13.7308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.256 13.7308H242.795V21.9109H244.256V13.7308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.838 101.374C166.254 90.5648 161.287 80.3398 153.691 73.9126C145.511 67.1933 134.41 64.2718 121.556 65.4404V63.9797C134.702 62.519 146.096 65.4404 154.568 72.744C162.748 79.4633 167.714 89.9805 168.299 101.082L166.838 101.374Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.736 139.353C119.511 139.353 109.578 134.971 102.274 126.791C93.2175 116.858 87.3746 99.6213 97.5997 81.2162L98.7683 81.8005C88.8354 99.6213 94.3861 115.981 103.15 125.622C113.668 137.308 130.028 140.814 144.343 134.386L144.927 135.555C139.961 138.184 134.702 139.353 129.736 139.353Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.15 76.5419L102.274 75.6655C105.488 72.4519 108.701 69.8226 112.207 67.4855L113.083 68.654C109.286 70.6991 106.072 73.3284 103.15 76.5419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.232 94.8675L101.637 125.638L102.76 126.572L128.355 95.8017L127.232 94.8675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.877 117.003L109.413 132.096L110.539 133.027L123.004 117.933L121.877 117.003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.217 75.1966L129.068 108.095L130.195 109.025L157.344 76.1264L156.217 75.1966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.276 130.296L153.399 129.128C158.658 124.746 161.871 120.364 163.332 115.397L164.501 115.689C163.04 120.948 159.534 125.622 154.276 130.296Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.052 147.533C193.131 147.533 190.794 145.488 190.209 143.151C189.625 141.106 190.209 139.353 191.378 138.184C192.547 137.016 194.592 136.431 196.637 137.016L196.344 138.476C194.884 138.184 193.423 138.476 192.547 139.353C191.67 140.229 191.378 141.69 191.67 143.151C191.962 144.904 194.007 146.364 195.76 146.364C198.389 146.364 199.558 144.319 200.142 142.274L201.311 142.566C200.727 145.488 198.682 147.533 196.052 147.533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.3 165.938H218.84V169.152H220.3V165.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.93 165.938H247.47V174.41H248.93V165.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.93 145.488H247.47V150.454H248.93V145.488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.582 160.387H238.121V165.354H239.582V160.387Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.818 160.387H229.357V165.354H230.818V160.387Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.93 122.701H247.47V129.712H248.93V122.701Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.93 113.644H247.47V118.318H248.93V113.644Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.93 95.2391H247.47V101.082H248.93V95.2391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5088 168.567H66.0481V174.41H67.5088V168.567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4965 168.567H33.0358V173.534H34.4965V168.567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4409 163.017H49.9802V167.983H51.4409V163.017Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8778 167.983H11.4171V173.826H12.8778V167.983Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8107 162.14H21.35V167.983H22.8107V162.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8107 150.454H21.35V156.297H22.8107V150.454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8107 138.476H21.35V141.982H22.8107V138.476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8778 127.667H11.4171V137.308H12.8778V127.667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8778 115.397H11.4171V117.442H12.8778V115.397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8778 105.464H11.4171V110.139H12.8778V105.464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8778 86.767H11.4171V92.0256H12.8778V86.767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8107 122.701H21.35V126.206H22.8107V122.701Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.043 61.6425L255.65 47.0353L257.695 45.5746L267.628 58.1368L272.302 54.9232L255.65 33.0124L257.695 31.2595L276.1 55.7997L267.043 61.6425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.987 175.871H0.899902V19.2815L92.9254 20.7423L104.903 0H220.592L227.896 20.4501H257.987V175.871ZM3.5292 172.949H255.358V23.0794H226.143L218.84 2.6293H106.656L94.6782 23.3716L3.5292 22.203V172.949Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 169.152C92.9254 169.152 62.5424 138.769 62.5424 101.082C62.5424 63.6875 92.9254 33.0123 130.612 33.0123C168.299 33.0123 198.682 63.3954 198.682 101.082C198.682 138.769 168.006 169.152 130.612 169.152ZM130.612 35.9338C94.6782 35.9338 65.1717 65.1482 65.1717 101.374C65.1717 137.308 94.3861 166.814 130.612 166.814C166.546 166.814 196.052 137.6 196.052 101.374C195.76 65.1482 166.546 35.9338 130.612 35.9338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.32 146.072C105.488 146.072 85.0375 125.914 85.0375 100.79C85.0375 75.6654 105.195 55.5074 130.32 55.5074C155.444 55.5074 175.602 75.6654 175.602 100.79C175.602 125.914 155.152 146.072 130.32 146.072ZM130.32 59.0132C107.24 59.0132 88.5432 77.7104 88.5432 100.79C88.5432 123.869 107.24 142.566 130.32 142.566C153.399 142.566 172.097 123.869 172.097 100.79C172.097 77.7104 153.399 59.0132 130.32 59.0132Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.444 159.803C97.5998 159.803 71.3068 133.802 71.3068 101.666C71.3068 69.5304 97.5998 43.5295 129.444 43.5295C161.287 43.5295 187.58 69.5304 187.58 101.666C187.58 133.802 161.579 159.803 129.444 159.803ZM129.444 44.9903C98.1841 44.9903 72.4753 70.4068 72.4753 101.958C72.4753 133.218 97.8919 158.927 129.444 158.927C160.703 158.927 186.412 133.51 186.412 101.958C186.412 70.4068 160.995 44.9903 129.444 44.9903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.052 154.544C189.333 154.544 183.782 148.994 183.782 142.274C183.782 135.555 189.333 130.004 196.052 130.004C202.772 130.004 208.322 135.555 208.322 142.274C208.615 148.994 203.064 154.544 196.052 154.544ZM196.052 132.341C190.794 132.341 186.412 136.724 186.412 141.982C186.412 147.241 190.794 151.623 196.052 151.623C201.311 151.623 205.693 147.241 205.693 141.982C205.693 136.724 201.603 132.341 196.052 132.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.598 81.8005C35.3729 81.8005 26.9008 73.3283 26.9008 63.1033C26.9008 52.8782 35.3729 44.406 45.598 44.406C55.8231 44.406 64.2952 52.8782 64.2952 63.1033C64.2952 73.3283 55.8231 81.8005 45.598 81.8005ZM45.598 47.0353C36.8337 47.0353 29.8222 54.0468 29.8222 62.8111C29.8222 71.5754 36.8337 78.5869 45.598 78.5869C54.3623 78.5869 61.3738 71.5754 61.3738 62.8111C61.3738 54.0468 54.3623 47.0353 45.598 47.0353Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5981 75.3733C38.8787 75.3733 33.328 69.8225 33.328 63.1032C33.328 56.3839 38.8787 50.8331 45.5981 50.8331C52.3174 50.8331 57.8681 56.3839 57.8681 63.1032C57.8681 69.8225 52.3174 75.3733 45.5981 75.3733ZM45.5981 53.4624C40.3395 53.4624 35.9573 57.8446 35.9573 63.1032C35.9573 68.3618 40.3395 72.744 45.5981 72.744C50.8567 72.744 55.2388 68.3618 55.2388 63.1032C55.2388 57.8446 50.8567 53.4624 45.5981 53.4624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.277 46.7431C198.389 46.7431 191.67 40.3159 191.67 32.1359C191.67 24.248 198.097 17.5287 206.277 17.5287C214.165 17.5287 220.885 23.9559 220.885 32.1359C220.885 40.3159 214.165 46.7431 206.277 46.7431ZM206.277 20.4501C199.85 20.4501 194.299 25.7087 194.299 32.4281C194.299 38.8552 199.558 44.406 206.277 44.406C212.705 44.406 218.255 39.1474 218.255 32.4281C217.963 25.7087 212.705 20.4501 206.277 20.4501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.57 36.8103C209.151 36.8103 211.244 34.7175 211.244 32.136C211.244 29.5544 209.151 27.4617 206.57 27.4617C203.988 27.4617 201.895 29.5544 201.895 32.136C201.895 34.7175 203.988 36.8103 206.57 36.8103Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.00ecdc1ac90893e500d21a88937eda44.svg";
export { ForwardRef as ReactComponent };